import { useQuery } from 'react-query';
import { getAllSlots, getRoundAvailability, getRoundTemplateAvailability } from 'src/apis/userAvailability';
import { GetAllSlotsAPIResponse, GetRoundAvailabilityAPIResponse, GetRoundAvailabilityInput } from 'types';

export const useGetAllSlotsQuery = (id?: string, onComplete?: (data: GetAllSlotsAPIResponse) => void) => {
	return useQuery({
		queryKey: ['getAllSlots'],
		queryFn: async () => (await getAllSlots(id ?? '')) as GetAllSlotsAPIResponse,
		staleTime: 0,
		enabled: !!id,
		refetchOnMount: true,
		onSuccess(data) {
			onComplete && onComplete(data);
		},
	});
};
export const useGetAvailabilitiesForScheduling = (payload: GetRoundAvailabilityInput) => {
	return useQuery({
		queryKey: ['getAvailability', payload.round, payload.roundTemplateId],
		queryFn: async () => {
			if (payload.round)
				return (await getRoundAvailability({ round: payload.round })) as GetRoundAvailabilityAPIResponse;
			return (await getRoundTemplateAvailability({
				roundTemplateId: payload.roundTemplateId,
			})) as GetRoundAvailabilityAPIResponse;
		},
		staleTime: 0,
		enabled: !payload.isAIRound && (!!payload.round || !!payload.roundTemplateId),
		refetchOnMount: true,
	});
};
